import * as Constants from 'src/constants';
import BlogPage from 'src/views/Marketing/Blog/components/BlogPage';
import Footer from 'src/views/Marketing/components/Footer';
import NavBar from 'src/views/Marketing/components/NavBar';
import { ScrollView, StyleSheet } from 'react-native';

export default function Page() {
  return (
    <ScrollView style={styles.scrollView}>
      <NavBar />
      <BlogPage author='Ryan Hill' dateTime='2023-04-18' tag='Policy' title='Item Authentication'>
        <p>
          OneShop is a marketplace focused on purchasing bundles from trusted sellers. We do <b>not</b> authenticate
          individual items within a bundle, nor do we require authentication documentation from sellers.
        </p>
        <p>
          Buyers desiring authentication may contact the seller directly with their request. However, the seller is not
          obligated to provided this information and may charge extra for it.
        </p>
        <p>
          OneShop's buyer protections do not cover item authentication. Listings believed to be inauthentic may undergo
          our standard{' '}
          <a style={{ color: Constants.BrandColor.Bolt }} href='/policies/buyer-protections'>
            return policy
          </a>
          .
        </p>
        <p>
          Sellers with repeated returns or reports related to inauthentic items may be subject to suspension or removal
          from the platform.
        </p>
      </BlogPage>
      <Footer />
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});
